
import { InjectionToken } from '@angular/core';

export const PRODUCT_SERVICE_KEYS = new InjectionToken<ProductSpecificService>('ProductService');

export abstract class ProductSpecificService {
  product: string;
  adminDashboardRoute: string;
}
